import React from 'react';

// Sprint 004 — ErrorBoundary supaya error di komponen mana pun TIDAK
// black-out seluruh app. User tetap lihat header/sidebar + pesan error
// dengan tombol Reload + clipboard copy untuk debugging.
//
// Tanpa ini: any uncaught render error → React unmount whole tree →
// pure black screen (user sees nothing → think app dead).

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] caught:', error);
    console.error('[ErrorBoundary] component stack:', info?.componentStack);
    this.setState({ info });
  }

  reset = () => this.setState({ error: null, info: null });

  copyDetail = () => {
    const txt = `${this.state.error?.message || 'Unknown error'}\n\n${this.state.error?.stack || ''}\n\nComponent stack:${this.state.info?.componentStack || '—'}`;
    try { navigator.clipboard?.writeText(txt); } catch { /* ignore */ }
  };

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'rgba(2,6,14,0.92)', backdropFilter: 'blur(4px)',
        padding: 24, fontFamily: 'var(--font-sans), system-ui, sans-serif',
      }}>
        <div style={{
          maxWidth: 560, width: '100%',
          background: '#0b1425', border: '1px solid rgba(255,45,85,0.4)',
          borderRadius: 24, padding: 28,
          boxShadow: '0 12px 48px rgba(255,45,85,0.25)',
          color: '#e4eaf4',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
            <span style={{ fontSize: 20 }}>⚠</span>
            <h2 style={{ fontSize: 14, fontWeight: 900, color: '#ff6b7a', margin: 0, letterSpacing: 1.5, textTransform: 'uppercase' }}>
              KESALAHAN APP
            </h2>
          </div>
          <p style={{ fontSize: 12, color: '#cfd8e3', marginBottom: 14, lineHeight: 1.5 }}>
            Komponen UI mengalami error. Halaman utama dipertahankan supaya bisa lanjut bekerja.
          </p>
          <div style={{
            background: '#02060e', border: '1px solid rgba(255,45,85,0.25)',
            borderRadius: 12, padding: 12, marginBottom: 16,
            fontFamily: 'IBM Plex Mono, monospace', fontSize: 11,
            color: '#ff6b7a', overflow: 'auto', maxHeight: 200,
          }}>
            {this.state.error?.message || 'Unknown error'}
            {this.state.error?.stack && (
              <pre style={{ marginTop: 8, fontSize: 10, color: '#94a3b8', whiteSpace: 'pre-wrap' }}>
                {this.state.error.stack.split('\n').slice(0, 6).join('\n')}
              </pre>
            )}
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={this.reset} style={{
              flex: 1, padding: '10px 16px', borderRadius: 12,
              background: 'rgba(0,212,255,0.12)', border: '1px solid rgba(0,212,255,0.4)',
              color: '#00d4ff', fontWeight: 900, fontSize: 12, cursor: 'pointer',
            }}>
              Coba Lagi
            </button>
            <button onClick={() => location.reload()} style={{
              flex: 1, padding: '10px 16px', borderRadius: 12,
              background: 'rgba(255,107,43,0.12)', border: '1px solid rgba(255,107,43,0.4)',
              color: '#ff6b2b', fontWeight: 900, fontSize: 12, cursor: 'pointer',
            }}>
              Reload Halaman
            </button>
            <button onClick={this.copyDetail} style={{
              padding: '10px 16px', borderRadius: 12,
              background: 'rgba(148,163,184,0.10)', border: '1px solid rgba(148,163,184,0.3)',
              color: '#cfd8e3', fontWeight: 900, fontSize: 12, cursor: 'pointer',
            }}>
              Copy Detail
            </button>
          </div>
        </div>
      </div>
    );
  }
}
